import { AbstractControl, ValidationErrors } from "@angular/forms";

const tabs = [
    {
        icon: 'directions_boat',
        title: 'Vessel',
        description: 'Register vessel details including IMO, tonnage, and dimensions for audit records.',
        route: 'dis-mastertabs/vessel'
    },
    {
        icon: 'person',
        title: 'Client',
        description: 'Manage registered companies or organizations involved in your port operations.',
        route: 'dis-mastertabs/client'
    },
    // {
    //   icon: 'language',
    //   title: 'Country',
    //   description: 'Define and maintain country details used across ports, vessels, and documentation.',
    //   route: 'layout/masterdis-mastertabs/country'
    // },
    {
        icon: 'anchor',
        title: 'Port & Tariff',
        description: 'Set up ports with location data for vessel arrivals, departures, and audits.',
        route: 'dis-mastertabs/port'
    },
    {
        icon: 'account_circle',
        title: 'Port Agent',
        description: 'Add or update local agents responsible for coordinating vessel activities.',
        route: 'dis-mastertabs/port-agent'
    },

    {
        icon: 'garage_home',
        title: 'Cargo',
        description: 'Define cargo types transported by vessels for better tracking and reporting.',
        route: 'dis-mastertabs/cargo'
    },
    {
        icon: 'flag',
        title: 'Purpose',
        description: 'Specify voyage purposes—like bunkering, crew change, or cargo ops.',
        route: 'dis-mastertabs/purpose'
    },
    {
        icon: 'receipt_long',
        title: 'Tariff Fees',
        description: 'Manage Tariff services efficiently.',
        route: 'dis-mastertabs/tariff-services'
    },
    {
        icon: 'person_add',
        title: 'User Management',
        description: 'Manage users who have access to the system. Add or edit user details and assign roles.',
        route: 'dis-mastertabs/user-management',
    },

];

// Add method to format address for display
const formatAddressForDisplay = (address: string): string => {
    return address ? address.replace(/\\n/g, '\n') : '';
}

// Add method to format address for storage
const formatAddressForStorage = (address: string): string => {
    return address ? address.replace(/\n/g, '\\n') : '';
}

// method to prevent the numeric input on copy paste
const handlePasteText = (event: ClipboardEvent): string => {
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;

    const selectionStart = target.selectionStart ?? currentValue.length;
    const selectionEnd = target.selectionEnd ?? currentValue.length;
    const selectedLength = selectionEnd - selectionStart;

    const currentLength = currentValue.length;
    const availableSpace = 50 - (currentLength - selectedLength);

    //  If no space to insert anything, block paste
    if (availableSpace <= 0) {
        event.preventDefault();
        return currentValue;
    }

    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    const filteredText = pastedText.replace(/[^a-zA-Z\s]/g, '');

    // Only allow as many characters as will fit
    const allowedText = filteredText.slice(0, availableSpace);

    // Insert filtered text at cursor/selection
    const newValue =
        currentValue.slice(0, selectionStart) +
        allowedText +
        currentValue.slice(selectionEnd);

    return newValue?.trim();
}

// This method will allow only letters and space in the input field
const allowOnlyLetters = (event: KeyboardEvent) => {
    const regex = /^[A-Za-z\s]+$/;
    const inputChar = String.fromCharCode(event.keyCode || event.which);
    if (!regex.test(inputChar)) {
        event.preventDefault();
    }
};

//method to allow the limited length of input
const allowLimitedInput = (event: KeyboardEvent, limit: any) => {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) return;
    const input = event.target as HTMLInputElement;
    if (input.value.length == limit) {
        event.preventDefault();
    }
};

// method to trim the input
const trimInput = (control: AbstractControl | null): void => {
    if (control && typeof control.value === 'string') {
        const trimmed = control.value.replace(/\s{2,}/g, ' ').trim();
        control.setValue(trimmed, { emitEvent: false });
    }
}


export {
    tabs, handlePasteText, allowOnlyLetters, allowLimitedInput, trimInput,
    formatAddressForDisplay,
    formatAddressForStorage
}